<div id="loading-area">
  <p>
    <span class="counter">100</span>
  </p>
</div>
